import api from './api';

export const analyzeCareer = async (data) => {
  const response = await api.post('/api/analysis/career', data);
  return response.data;
};
